import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/client/components/app-router.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/client/components/builtin/global-error.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/client/components/client-page.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/client/components/client-segment.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/client/components/http-access-fallback/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/client/components/layout-router.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/client/components/metadata/async-metadata.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/client/components/render-from-template-context.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/client/components/router-reducer/fetch-server-response.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/client/components/router-reducer/set-cache-busting-search-param.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/lib/framework/boundary-components.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/lib/metadata/generate/icon-mark.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/shared/lib/app-router-context.shared-runtime.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/shared/lib/hooks-client-context.shared-runtime.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src1535834765/src/dgbet/node_modules/next/dist/shared/lib/server-inserted-html.shared-runtime.js");
